import { MessageSquareText, Sparkles, ArrowRight, FileText, Zap, Bot, UserRound, Search, Wrench, Brain, ListTree, Users, Workflow, CheckCircle2, SlidersHorizontal } from "lucide-react";

const Node = ({ icon: I, label, c = "bg-white text-blue-600" }) => (
  <div className="flex flex-col items-center gap-1">
    <span className={`grid h-11 w-11 place-items-center rounded-xl shadow-sm ${c}`}><I className="h-5 w-5" /></span>
    <span className="text-[11px] font-medium text-slate-700">{label}</span>
  </div>
);
const Arrow = () => <ArrowRight className="h-4 w-4 shrink-0 text-slate-500" />;

const Llm = () => (
  <div className="flex items-center gap-3 rounded-xl bg-white/80 p-3 shadow-sm">
    <MessageSquareText className="h-10 w-10 shrink-0 text-[#0E9384]" strokeWidth={1.5} />
    <div className="flex-1 rounded-lg border border-teal-100 bg-white px-3 py-2 text-[13px] text-slate-800">Explain how this support-ticket app uses an LLM, step by step</div>
    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-[#0E9384] text-white"><Sparkles className="h-4 w-4" /></span>
  </div>
);

const Flow = () => (
  <div className="flex items-center justify-between rounded-xl bg-white/80 p-3 shadow-sm">
    <Node icon={Zap} label="Trigger" c="bg-blue-50 text-blue-600" /><Arrow />
    <Node icon={FileText} label="Extract" c="bg-blue-50 text-blue-600" /><Arrow />
    <Node icon={Sparkles} label="AI step" c="bg-blue-600 text-white" /><Arrow />
    <Node icon={UserRound} label="Review" c="bg-blue-50 text-blue-600" />
  </div>
);

const Prompt = () => (
  <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2 rounded-xl bg-white/80 p-3 shadow-sm">
    <div className="space-y-1.5 text-[11px]">
      {["Task", "Context", "Output spec"].map((t) => <div key={t} className="rounded-md border border-blue-100 bg-white px-2 py-1 font-medium text-blue-700">{t}</div>)}
    </div>
    <SlidersHorizontal className="h-6 w-6 text-blue-500" />
    <div className="space-y-1.5 text-[11px]">
      {["Case 1 pass", "Case 2 pass", "Edge case: fix"].map((t, i) => (
        <div key={t} className="flex items-center gap-1.5 rounded-md bg-white px-2 py-1 text-slate-700"><CheckCircle2 className={`h-3.5 w-3.5 ${i < 2 ? "text-emerald-500" : "text-sky-500"}`} />{t}</div>
      ))}
    </div>
  </div>
);

const Agent = () => (
  <div className="rounded-xl bg-white/80 p-3 shadow-sm">
    <div className="flex items-center justify-between gap-2">
      <Node icon={UserRound} label="Request" c="bg-slate-100 text-[#0B1B33]" /><Arrow />
      <Node icon={Bot} label="Agent" c="bg-[#0B1B33] text-white" /><Arrow />
      <div className="space-y-1 text-[11px]">
        {[[Search, "Retrieve"], [Wrench, "Use tools"], [Workflow, "Act"]].map(([I, t]) => <div key={t} className="flex items-center gap-1.5 rounded-md bg-white px-2 py-0.5 text-slate-700"><I className="h-3 w-3 text-[#0E9384]" />{t}</div>)}
      </div>
    </div>
    <div className="mt-3 grid grid-cols-4 gap-1 border-t border-slate-200 pt-2">
      {[[Brain, "Memory"], [ListTree, "Planning"], [Wrench, "Tools"], [Users, "Multi-Agent"]].map(([I, t]) => (
        <div key={t} className="flex flex-col items-center text-[10.5px] text-slate-700"><I className="h-4 w-4 text-[#0E9384]" />{t}</div>
      ))}
    </div>
  </div>
);

export const VISUALS = { llm: Llm, workflow: Flow, prompt: Prompt, agent: Agent };
